export function hasCookie(cookieName: string) {
    return Object.keys(getCookies()).includes(cookieName);
}

export function setCookie(name: string, value: unknown, days = 1) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    // biome-ignore lint/suspicious/noDocumentCookie: this is the cookie utility
    document.cookie = `${name}=${value}${expires}; path=/`;
}

export function setCookies(cookies: { [s: string]: unknown } | ArrayLike<unknown>) {
    Object.entries(cookies).forEach((entry) => {
        const [name, value] = entry;
        setCookie(name, value);
    });
}

export function getCookie(search: string) {
    return document.cookie
        .split(';')
        .map((item) => item.split(/\s?(.*?)=(.*)/).splice(1, 2))
        .find(([name]) => name === search)?.[1];
}

type Cookie = {
    [key: string]: string | number;
};

export function getCookies() {
    return document.cookie.split(';').reduce<Cookie>((prev, current) => {
        const [name, value] = current.split(/\s?(.*?)=(.*)/).splice(1, 2);
        prev[name] = value;
        return prev;
    }, {});
}
